import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import type { TransactionRecord } from 'app-components/flux/transactions/transactionsTypes';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'TRANSACTION_DETAILS_DIALOG';

export const showTxnDetailsDialog = createAction(
  rootUiActions.createDialog.toString(),
  ({
    txn,
    wrapperId,
    txnActionCallback,
    defaultAccountId,
    ...otherProps
  }: {
    recurring?: string;
    txn?: TransactionRecord;
    txnActionCallback?: () => void;
    wrapperId?: string;
    defaultAccountId?: string | null;
  }) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      id: `TRANSACTION_DETAILS_${txn?.id || '0'}`,
      props: ImmutableMap({ txn, wrapperId, txnActionCallback, defaultAccountId, ...otherProps }),
    }),
);
